import React, { useState } from "react";
import { Spin } from "antd";
import Header from "./Header";
import WelcomeSection from "./WelcomeSection";
import StatsSection from "./StatsSection";
import TrainingSection from "./TrainingSection";
import SidebarSection from "./SidebarSection";
import { LoadingOutlined } from "@ant-design/icons";
import useMentorDashboard from  "PlatForms/OrgLMS/Hooks/MentorHooks/useMentorDashboard";
const MentorDashboard = () => {
  const { dashboardData, loading, error } = useMentorDashboard();
  const [darkMode, setDarkMode] = useState(false);
  const spinnerIcon = <LoadingOutlined style={{ fontSize: 48, color: "#9A6B0E" }} spin />;
  if (loading) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "80vh",
        backgroundColor: darkMode ? "#141414" : "#fff",
      }}>
        <Spin indicator={spinnerIcon} tip="Loading..." size="large" />
      </div>
    );
  }
  if (error) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "80vh",
        color: darkMode ? "#fff" : "#000",
      }}>
        ⚠️ Error: {error}
      </div>
    );
  }
  if (!dashboardData) {
    return <div style={{ padding: "8px" }}>No data available</div>;
  }
  return (
    <div style={{
      maxWidth: 1400,
      margin: "0 auto",
      padding: "8px",
      backgroundColor: darkMode ? "#141414" : "#FAF8F3",
      minHeight: "100vh",
    }}>
      <Header darkMode={darkMode} setDarkMode={setDarkMode} />
      <div style={{ marginBottom: "8px" }}>
        <WelcomeSection
          darkMode={darkMode}
          mentor={dashboardData.mentor}
          performanceRatingCount={dashboardData.performanceRatingCount}
          learnerCount={dashboardData.learnerCount}
          performanceRating={dashboardData.performanceRating}
        />
      </div>
      <div style={{ marginBottom: "8px" }}>
        <StatsSection
          darkMode={darkMode}
          learnerCount={dashboardData.learnerCount}
          learnerMonthCount={dashboardData.learnerMonthCount}
          inflightCount={dashboardData.inflightCount}
          performanceRating={dashboardData.performanceRating}
          completedCount={dashboardData.completed}
          performanceRatingCount={dashboardData.performanceRatingCount}
        />
      </div>
      <div style={{
        display: "grid",
        gridTemplateColumns: "minmax(0, 2fr) minmax(0, 1fr)",
        gap: "8px",
      }}>
        <TrainingSection darkMode={darkMode} trainings={dashboardData.trainings} />
        <SidebarSection darkMode={darkMode} ratings={dashboardData.ratings} />
      </div>
    </div>
  );
};
export default MentorDashboard;